import Grid from "@mui/material/Grid2";
import TextField from "@mui/material/TextField";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

export default function PersonalForm() {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const handlePhoneInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.target.value = e.target.value.replace(/\D/g, "");
  };
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 6 }}>
        <Controller
          name="firstName"
          control={control}
          rules={{ required: t("The first name field is required") }}
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              label={`${t("Name")} *`}
              placeholder=""
              error={!!error}
              helperText={error ? error.message : ""}
              fullWidth
              autoComplete="new-first-name"
              name="new-first-name"
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <Controller
          name="lastName"
          control={control}
          rules={{ required: t("The last name field is required") }}
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              label={`${t("Surname")} *`}
              placeholder=""
              error={!!error}
              helperText={error ? error.message : ""}
              fullWidth
              autoComplete="new-last-name"
              name="new-last-name"
            />
          )}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Controller
          name="email"
          control={control}
          rules={{
            required: t("The email field is required"),
            pattern: {
              value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
              message: t("Email is invalid"),
            },
          }}
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              label="Email *"
              placeholder=""
              error={!!error}
              helperText={error ? error.message : ""}
              fullWidth
              autoComplete="new-email"
              name="new-email"
            />
          )}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Controller
          name="phone"
          control={control}
          rules={{
            required: t("The phone number field is required"),
            // validate: value =>
            //   value.length === 10 || t("The phone number must have 10 characters."),
          }}
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              label={`${t("Phone number")} *`}
              placeholder=""
              error={!!error}
              helperText={error ? error.message : ""}
              fullWidth
              onInput={handlePhoneInput}
              name="new-phone-number"
              autoComplete="new-phone-number"
            />
          )}
        />
      </Grid>
    </Grid>
  );
}
